import React, {Component} from "react";
import { Col, Container, Row } from "react-bootstrap";
import CommonService from "../services/common.service";
import userEventService from "../services/user-event.service";

let common = new CommonService();
interface TextPageProps {
    pageId: string;
}

interface TextPageState {
    pageTitle: string;
    pageContent: string;
}

class TextPage extends Component<TextPageProps, TextPageState> {
    constructor(props: any) {
        super(props);
        this.state = {
            pageTitle: "",
            pageContent: ""
        };
    }

    componentDidMount(): void {
        userEventService.sendEvent('page_view', 'text_page_open', { pageId: this.props.pageId });
        common.getPage(this.props.pageId).then((res) => {
            this.setState({
                pageTitle: res.page_title,
                pageContent: res.page_content
            });
        }).catch((err) => {
            console.error("Failed to fetch page data:", err);
        });
    }

    render() {
        return (
            <>
                <Container className="oc-mainpage">
                    <Row>
                        <Col key={'pageContent'} lg={6} md={6} sm={12} xs={12}>
                            <h2>{this.state.pageTitle}</h2>
                            <div dangerouslySetInnerHTML={{ __html: this.state.pageContent }} />
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }
}

export default TextPage;